import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useAuth from "common/hooks/useAuth";
import SectorForm from "./SectorForm";

function Sector() {
  const { t } = useTranslation();
  const router = useRouter();
  const { user: currentUser } = useAuth();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "sectors",
    id,
    {}
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate(currentUser?.isSuperadmin ? "/sectors" : "/");
    }
  }, [setAlert, router, error, currentUser, t]);

  const onSubmit = useCallback(
    async (dataSector: any) => {
      const newSector = { ...dataSector };

      try {
        if (newSector.id) {
          await updateItem(newSector.id, newSector);
        } else {
          await saveItem(newSector);
        }
      } catch (e: any) {
        return e;
      }
      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <SectorForm onSubmit={onSubmit} sector={item} />
  );
}

export default Sector;
